import type {CellRendererType} from '../types/EagColumn';

// FLAG is wrappable on purpose: FLAG cells carry chip ARRAYS (e.g. the
// requirements column on messaging-customer-message) and in WRAP mode the
// chips must flow onto the next line instead of being clipped at the cell
// edge — otherwise the grid looks like it hides content that cannot be
// scrolled to (T20-134770). Single-flag cells behave like TAG cells.
const NON_WRAPPABLE: ReadonlySet<CellRendererType> = new Set<CellRendererType>([
  'THUMBNAIL',
  'CHECKBOX',
  'FILE',
  'FILE_PLAIN',
]);

export const isWrappableType = (type: CellRendererType): boolean => !NON_WRAPPABLE.has(type);
